import { HttpBackend, HttpClient, HttpEventType, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { last, Observable, switchMap, tap } from "rxjs";
import { EnTipoEnvio, ParticipanteExternoAtivo } from "./chat-export.types";

@Injectable({
    providedIn: 'root'
})
export class ChatExportService {

    private _httpStorage: HttpClient;

    public progress: number = 0;

    constructor(private _httpClient: HttpClient, httpBackend: HttpBackend) {
        this._httpStorage = new HttpClient(httpBackend);
    }

    validateParticipanteExterno(chatApiUrl: string, mensagemGuid: string, catalogo: string, token: string): Observable<ParticipanteExternoAtivo> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`
        });
        const params = new HttpParams()
            .set('mensagemGuid', mensagemGuid)
            .set('catalogo', catalogo);

        return this._httpClient.get<ParticipanteExternoAtivo>(
            `${chatApiUrl}Mensagem/validate/participante-externo`,
            { headers, params }
        );
    }

    postExport(
        chatApiUrl: string,
        chaveSignalR: string,
        anexo: File,
        tipoEnvio: EnTipoEnvio,
        destino: string,
        participanteExternoAtivo: Partial<ParticipanteExternoAtivo>
    ): Observable<any> {
        const cabecalhos = new HttpHeaders()
            .append('sessaoAuth', chaveSignalR)

        const assinar = new HttpParams()
            .set('arquivo', anexo.name)
            .set('tamanho', anexo.size);

        return this._httpClient.post<{ url: string, arquivo: string }>(`${chatApiUrl}Arquivo/export/url`, null, {
            headers: cabecalhos,
            params: assinar
        }).pipe(
            switchMap(assinada => this.enviarParaStorage(assinada.url, anexo).pipe(
                last(null, null),
                switchMap(() => this._httpClient.post(`${chatApiUrl}Arquivo/export/confirmar`, participanteExternoAtivo, {
                    headers: cabecalhos,
                    params: new HttpParams()
                        .set('arquivo', assinada.arquivo)
                        .set('tamanho', anexo.size)
                        .set('tipoEnvio', tipoEnvio)
                        .set('destino', destino)
                }))
            ))
        );
    }

    private enviarParaStorage(url: string, anexo: File): Observable<any> {
        return this._httpStorage.put(url, anexo, {
            headers: new HttpHeaders({ 'Content-Type': anexo.type || 'application/octet-stream' }),
            reportProgress: true,
            observe: 'events'
        }).pipe(
            tap((evento: any) => {
                if (evento.type === HttpEventType.UploadProgress) {
                    this.progress = Math.round(evento.loaded / evento.total * 100);
                }

                if (evento.type === HttpEventType.Response) {
                    this.progress = 0;
                }
            })
        );
    }

    
}